<template>
  <div>
    <v-toolbar flat dense>
      <!-- <router-back /> -->
      <div class="text-h6">Tutorials</div>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search.text"
        style="max-width: 300px"
        rounded
        dense
        filled
        placeholder="Search"
        hide-details
        autocomplete="new-password"
      >
        <template v-slot:prepend-inner>
          <font-awesome-icon icon="search" class="mt-1 mr-1" />
        </template>
      </v-text-field>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- <v-container class="fill-height">
      <v-row class="fill-height justify-center">Coming Soon</v-row>
    </v-container> -->
    <v-container class="px-5">
      <div v-for="(section, index) in sections" :key="'c' + index">
        <v-subheader>{{ section.category }}</v-subheader>
        <v-divider></v-divider>
        <v-row>
          <v-col
            v-for="(vid, index) in section.videos"
            :key="'v' + index"
            class="d-flex child-flex"
            cols="12"
            sm="6"
          >
            <v-card tile class="d-flex flex-column">
              <div>
                <div style="position: relative; padding-top: 56.25%">
                  <iframe
                    :src="vid.src"
                    frameborder="0"
                    allowfullscreen
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                    "
                  ></iframe>
                </div>
              </div>

              <div class="pa-2">
                <div
                  class="d-flex justify-space-between align-center font-weight-medium"
                >
                  <span>{{ vid.title }}</span>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment, { min } from "moment";

export default {
  data() {
    return {
      search: {
        filters: ["Sales", "Payments", "Products", "Customers"],
        filter: 3,
        text: null,
      },
    };
  },
  watch: {
    "search.filter": function (val) {
      this.search.text = "";
    },
    "search.text": function (val) {
      // this.searchProducts({
      //   type: this.search.filters[this.search.filter],
      //   term: this.search.text
      // });
    },
  },
  computed: {
    ...mapState({
      help: (state) => state.help,
    }),
    ...mapGetters({
      videos: "help/videos",
    }),

    sections() {
      var map = {};
      this.videos.forEach((vid) => {
        if (map.hasOwnProperty(vid.category)) {
          map[vid.category].videos.push(vid);
        } else {
          map[vid.category] = {
            category: vid.category,
            videos: [vid],
          };
        }
      });
      return map;
    },
  },
  methods: {
    ...mapActions({}),
  },
};
</script>
